import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-preview-descriptive-plain-text',
  templateUrl: './preview-descriptive-plain-text.component.html',
  styleUrls: ['./preview-descriptive-plain-text.component.scss']
})
export class PreviewDescriptivePlainTextComponent implements OnInit {
  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  descriptiveQuestion: any;
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.descriptiveQuestion = this.questions?.questiondescription?.description;//.replace( /(<([^>]+)>)/ig, '')
  }
}
